import { useEffect, useState } from "react";
import { getCitiesOrganizationById_V2 } from "../Services_V2/Organization.service";
import toast from "react-hot-toast";
import { showError } from "../utils/error";

interface UseOrganizationCitiesResult {
    cities: any[];
    loading: boolean;
    error: string | null;
    refetch: () => Promise<void>;
}

const useOrganizationCities = (organizationId?: string): UseOrganizationCitiesResult => {
    const [cities, setCities] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const fetchCities = async () => {
        if (!organizationId) {
            setCities([]);
            setLoading(false);
            setError(null);
            return;
        }

        try {
            setLoading(true);
            setError(null);

            const response = await getCitiesOrganizationById_V2(organizationId);
            const fetchedCities = response?.data ?? response ?? [];

            setCities(Array.isArray(fetchedCities) ? fetchedCities : []);
        } catch (err: any) {
            const errorMessage = "Failed to load organization cities";
            setError(errorMessage);
            showError(err);
            toast.error(errorMessage);
            setCities([]);
        } finally {
            setLoading(false);
        }
    };

    const refetch = async () => {
        await fetchCities();
    };

    useEffect(() => {
        fetchCities();
    }, [organizationId]);

    return { cities, loading, error, refetch };
};

export default useOrganizationCities;